import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getContainers as getContainersApi,
  getContainersGetFilters as getContainersGetFiltersApi,
  getContainersGetFiltersExport as getContainersGetFiltersExportApi,
  getContainerByID as getContainerByIDApi,
  getContainersStats as getContainersStatsApi,
  getContainersGenStats as getContainersGenStatsApi,
  getContainersFilterAll as getContainersFilterAllApi,
  getContainersFilter as getContainersFilterApi,
  addNewContainer as addNewContainerApi,
  updateContainer as updateContainerApi,
  deleteContainer as deleteContainerApi,
  addNewContainerGetFilters as addNewContainerGetFiltersApi,
  updateContainerGetFilters as updateContainerGetFiltersApi,
  deleteContainerGetFilters as deleteContainerGetFiltersApi,
  getBWarehouses as getBWarehousesApi,
} from "../../helpers/realbackend_helper";

// export const getContainers = createAsyncThunk(
//   "container/getContainers",
//   async () => {
//     try {
//       const response = await getContainersApi();
//       return response;
//     } catch (error) {
//       return error;
//     }
//   }
// );

export const getContainers = createAsyncThunk(
  "container/getContainers",
  async () => {
    try {
      const response = await getContainersApi();
      return response;
    } catch (error) {
      console.log("Error fetching containers:", error);
      return error;
    }
  }
);

export const getBWarehouses = createAsyncThunk(
  "container/getBWarehouses",
  async () => {
    try {
      const response = await getBWarehousesApi();
      return response;
    } catch (error) {
      console.log("Error fetching warehouses:", error);
      return error;
    }
  }
);

export const getContainersGetFilters = createAsyncThunk(
  "container/getContainersGetFilters",
  async (filters, thunkAPI) => {
    try {
      const response = await getContainersGetFiltersApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        typeof error === "string" ? error :
        (error.response?.data?.message || error.message || "Өгөгдөл татахад алдаа гарлаа")
      );
    }
  }
);

export const getContainersGetFiltersExport = createAsyncThunk(
  "container/getContainersGetFiltersExport",
  async (filters, thunkAPI) => {
    try {
      const response = await getContainersGetFiltersExportApi(filters);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        typeof error === "string" ? error :
        (error.response?.data?.message || error.message || "Өгөгдөл татахад алдаа гарлаа")
      );
    }
  }
);

export const getContainerByID = createAsyncThunk(
  "container/getContainerByID",
  async (container) => {
    try {
      const response = await getContainerByIDApi(container);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getContainersStats = createAsyncThunk(
  "container/getContainersStats",
  async ({ beginDate, lastDate, company }, { rejectWithValue }) => {
    try {
      const response = await getContainersStatsApi(
        beginDate,
        lastDate,
        company
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Stats");
    }
  }
);

export const getContainersGenStats = createAsyncThunk(
  "container/getContainersGenStats",
  async ({ beginDate, lastDate, company }, { rejectWithValue }) => {
    try {
      const response = await getContainersGenStatsApi(
        beginDate,
        lastDate,
        company
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Stats");
    }
  }
);

// export const getContainersStats = createAsyncThunk(
//   "container/getContainersStats",
//   async (container) => {
//     try {
//       const response = await getContainersStatsApi(container);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   }
// );

// export const getContainersGenStats = createAsyncThunk(
//   "container/getContainersGenStats",
//   async (container) => {
//     try {
//       const response = await getContainersGenStatsApi(container);
//       return response;
//     } catch (error) {
//       return error;
//     }
//   }
// );

export const getContainersFilterAll = createAsyncThunk(
  "container/getContainersFilterAll",
  async () => {
    try {
      const response = await getContainersFilterAllApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getContainersFilter = createAsyncThunk(
  "container/getContainersFilter",
  async () => {
    try {
      const response = await getContainersFilterApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewContainer = createAsyncThunk(
  "container/addNewContainer",
  async (container) => {
    try {
      const response = addNewContainerApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateContainer = createAsyncThunk(
  "container/updateContainer",
  async (container) => {
    try {
      const response = updateContainerApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteContainer = createAsyncThunk(
  "container/deleteContainer",
  async (container) => {
    try {
      const response = deleteContainerApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { container, ...response };
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

//===================== NEW =============================

export const addNewContainerGetFilters = createAsyncThunk(
  "container/addNewContainerGetFilters",
  async (container) => {
    try {
      const response = addNewContainerGetFiltersApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateContainerGetFilters = createAsyncThunk(
  "container/updateContainerGetFilters",
  async (container) => {
    try {
      const response = updateContainerGetFiltersApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteContainerGetFilters = createAsyncThunk(
  "container/deleteContainerGetFilters",
  async (container) => {
    try {
      const response = deleteContainerGetFiltersApi(container);
      toast.success("Чингэлэгийн мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { container, ...response };
    } catch (error) {
      toast.error("Чингэлэгийн мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);
